import { Component, OnInit, Inject, Input, ViewChild, HostListener, Renderer2, ElementRef } from '@angular/core';  
import { ActivatedRoute, ParamMap, RoutesRecognized } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Event as NavigationEvent } from "@angular/router";
import { NavigationEnd } from "@angular/router";
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';
import { DataStorage } from '../../core/helper/data.storage';
import { PmdSidebar } from 'src/app/shared/propeller';
import { CommonService } from 'src/app/core/helper/common.service';

@Component({
  selector: 'app-before-login-layout',
  templateUrl: './before-login-layout.component.html',
  styleUrls: ['./before-login-layout.component.scss']
})
export class BeforeLoginLayoutComponent implements OnInit {

  @ViewChild(PmdSidebar) leftSidebar ;

  titleObj:any = {};
  sideBarOverlay = false;

  public activated: {
    home: boolean;
  }

  // private router: Router;

  public childID: string;
	public id: string;
	public isLoading: boolean;

	private childParamSubscription: Subscription;
	private paramSubscription: Subscription;
	private timer: number;

  localMessage :any = {}

  isOpenc = true
  
  constructor( private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private dataStorage: DataStorage, 
    private commonService : CommonService, 
    @Inject(DOCUMENT) document, 
    private render: Renderer2, 
    private _elementRef: ElementRef
  ) {     

    this.dataStorage.dataStorageMessage.subscribe(message => { 
      this.localMessage = { title : message['title'], subtitle : message['subtitle']}
      this.localMessage = message
    });

    this.commonService.sideBarToggle.subscribe((data) => {
      this.leftSidebar.toggleSideBar();
      this.sideBarOverlay = true;
    })  
  }

  // Add or Remove class navbar
  NavbarSmallScrolled(){
    let navbar = this._elementRef.nativeElement.querySelector('.pmd-navbar');
    if (window.pageYOffset > 10) {
        navbar.classList.add('navbar-sm');
    } else{
        navbar.classList.remove('navbar-sm');
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    this.NavbarSmallScrolled();
  }

  @HostListener('window:resize', ['$event']) onResize(event: any) {
    this.NavbarSmallScrolled();
  }

  // languageForm: FormGroup;
  language = 'en';
  languages = [
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'fr', name: 'French' },
    { id: 'ar', name: 'Arabic' },
    { id: 'ru', name: 'Russian'}
  ];

  isOpenSidebar = false

  closeSidebar(){
    this.isOpenSidebar = false;
  }

  changeLang(){
    // console.log('===========change language======', this.language)
    this.commonService.changeLanguage(this.language)
  }

  openSidebar(){
    this.isOpenSidebar = true;
  }

  skipContentFocusAdd(){
    document.body.classList.add('skip-body-focus');
  }
  skipContentFocusRemove(){
    document.body.classList.remove('skip-body-focus');
  }

  public innerWidth: any;
  ngOnInit() {
    this.NavbarSmallScrolled();
    this.titleObj =  this.activatedRoute.snapshot.firstChild.data;

  }

  stopPropogation(event) {
    event.stopPropagation();
  }

  redirectTo(path){
    this.router.navigate([path]);
  }

  public isOpen: boolean;

  ngAfterViewInit() {
    this.NavbarSmallScrolled();
  }
 

}
